import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { booleanColor } from "@lib/helpers/ColorHelper";
import { shortenString } from "@lib/helpers/StringHelper";
import { Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { MdVerified } from "react-icons/md";
import { SendByteScannedTransaction } from "@lib/types";
import CoinPriceTextFormat from "@lib/components/MiniComponents/Others/CoinPriceTextFormat";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { TableColumnsProps } from "@lib/types/General";

type Props<T> = TableColumnsProps<T>;

const getColumns = <T extends SendByteScannedTransaction>(
  props: Props<T>,
): ColumnsType<T> => {
  const { messages } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "TX ID",
      dataIndex: "txId",
      width: "150px",
      render: (txId) => (
        <TableIdButton text={`${shortenString(txId)}`} textToBeCopied={txId} />
      ),
    },

    {
      title: "common.fromWalletAddress",
      dataIndex: "fromWalletAddress",
      width: "190px",
      render: (fromWalletAddress) => (
        <TableIdButton
          text={`${shortenString(fromWalletAddress)}`}
          textToBeCopied={fromWalletAddress}
        />
      ),
    },

    {
      title: "common.usdEquivalent",
      dataIndex: "convertedAmount",
      width: "145px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.convertedTo}
          showCurrency={r?.convertedTo}
        />
      ),
    },

    {
      title: "common.amount",
      dataIndex: "amount",
      width: "185px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.sendByteWalletAddress?.network}
          showCurrency={r?.sendByteWalletAddress?.network}
          showCurrencyImage
        />
      ),
    },

    {
      title: "common.confirmStatus",
      dataIndex: "confirmed",
      width: "140px",
      render: (d) => (
        <Tag
          color={booleanColor(Boolean(d === "true"))}
          style={{
            display: "flex",
            alignItems: "center",
            width: "fit-content",
            gap: "3px",
          }}
        >
          {d === "true" && <MdVerified />}
          {
            (d === "true"
              ? messages["common.confirmed"]
              : messages["common.unconfirmed"]) as string
          }
        </Tag>
      ),
    },
    {
      title: "common.confirmedDate",
      dataIndex: "confirmedDate",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },

    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY"),
    },

    {
      title: "#",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "150px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="blockChain"
            href={record?.extraData?.transactionDetailUrl || null}
            targetBlank
            disabled={!record?.extraData?.transactionDetailUrl}
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};
export default getColumns;
